<script lang="ts">
	import { Paragraph } from "misc-ui"
	import type { InputOverlayButton } from "./types"
	import { Responsive } from "responsive"

	interface Props {
		prompt?: string | Array<string>
		invertWarning?: boolean
		buttons: {
			confirm: InputOverlayButton
			deny?: InputOverlayButton
		}
		closeOverlay: () => void
	}

	let { prompt = undefined, invertWarning = false, buttons, closeOverlay }: Props = $props()

	let isMobile = $derived(Responsive.isMobile)

	function handleKeyPress(e: KeyboardEvent) {
		if (e.key === "Enter") {
			buttons.confirm.onClick()
			closeOverlay()
		}
	}
</script>

<div class="overlay-confirm-container" class:isMobile>
	{#if prompt}
		<Paragraph textContent={prompt} />
	{/if}
	<span class="button-container">
		<button
			class="{invertWarning ? '' : 'cancel'} link-button"
			onclick={() => {
				buttons.deny?.onClick()
				closeOverlay()
			}}>{buttons.deny?.text ?? "Cancel"}</button
		>
		<button
			class={invertWarning ? "cancel" : ""}
			onclick={() => {
				buttons.confirm.onClick()
				closeOverlay()
			}}>{buttons.confirm.text}</button
		>
	</span>
</div>
<svelte:window onkeypress={handleKeyPress} />

<style>
	.overlay-confirm-container {
		min-width: 10rem;
		max-width: 40vw;
		width: 100%;
		margin-top: 2rem;
		display: flex;
		flex-direction: column;
		justify-content: space-evenly;
	}

	.overlay-confirm-container.isMobile {
		max-width: 80vw;
		padding-top: 1rem;
	}

	.isMobile .button-container {
		gap: 0.5rem;
		justify-content: center;
	}

	.isMobile :global(.paragraph) {
		color: var(--color-text);
		font-weight: bold;
		line-height: 1.25rem;
	}
</style>
